import { Outlet } from "react-router-dom";
import "./AdminDashboard.css";
import { useEffect } from "react";
import { useTiersWithDisplayName } from "../../hooks/useTiersWithDisplayName";
import { useAuthUser } from "../../hooks/useAuthUser";

const AdminDashboard = () => {
  const { isAdmin } = useAuthUser();
  const tiersWithSubscriptionName = useTiersWithDisplayName();
  useEffect(() => {}, [tiersWithSubscriptionName]);

  if (!isAdmin) {
    return <>You need to be Admin to access this page</>;
  }

  return (
    <>
      <Outlet></Outlet>
    </>
  );
};

export default AdminDashboard;
